import { isEmpty } from './utils';

const TOKEN_KEY = 'pm-token';
const USER_INFO = 'pm-user';

const { parse } = JSON;
const { stringify } = JSON;

const storage = {
  clear(key) {
    if (localStorage?.getItem(key)) {
      return localStorage.removeItem(key);
    }
    if (sessionStorage?.getItem(key)) {
      return sessionStorage.removeItem(key);
    }

    return null;
  },
  clearAppStorage() {
    localStorage?.clear();
    sessionStorage?.clear();
  },
  clearToken(tokenKey = TOKEN_KEY) {
    return storage.clear(tokenKey);
  },
  clearUserInfo(userInfo = USER_INFO) {
    return storage.clear(userInfo);
  },
  get(key) {
    if (localStorage?.getItem(key)) return parse(localStorage.getItem(key)) || null;
    if (sessionStorage?.getItem(key)) return parse(sessionStorage.getItem(key)) || null;

    return null;
  },
  getToken(tokenKey = TOKEN_KEY) {
    return storage.get(tokenKey);
  },
  getUserInfo(userInfo = USER_INFO) {
    return storage.get(userInfo);
  },
  set(value, key, isLocalStorage = true) {
    if (isEmpty(value)) return null;
    if (isLocalStorage && localStorage) return localStorage.setItem(key, stringify(value));
    if (sessionStorage) return sessionStorage.setItem(key, stringify(value));

    return null;
  },
  setToken(value = '', isLocalStorage = true, tokenKey = TOKEN_KEY) {
    return storage.set(value, tokenKey, isLocalStorage);
  },
  setUserInfo(value = '', isLocalStorage = true, userInfo = USER_INFO) {
    return storage.set(value, userInfo, isLocalStorage);
  },
};

export default storage;
